<div class="modal-header report-viewer-header">
    <div class="report-viewer-heading">
        <span class="report-viewer-heading__icon">
            <lucide-icon name="file-text" [size]="19"></lucide-icon>
        </span>
        <div class="report-viewer-heading__copy">
            <h5 class="modal-title" id="report-viewer-title">{{ 'COMMON.ACTIONS.REPORT' | translate }}</h5>
            <span class="report-viewer-subtitle" *ngIf="title">{{ title }}</span>
        </div>
    </div>
    <button type="button" class="close report-viewer-close" (click)="closeModal()"
            [attr.aria-label]="'COMMON.BUTTONS.CLOSE' | translate">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body report-viewer-body" tabindex="0">
    <ng-container *ngIf="isEmbeded">
        <powerbi-paginated-report [embedConfig]="reportConfig" [cssClassName]="'report-container'" [eventHandlers]="eventHandlers"></powerbi-paginated-report>
    </ng-container>
</div>

<div class="modal-footer report-viewer-footer">
    <button type="button" class="btn btn-primary report-viewer-action" (click)="reload()" rippleEffect>
        <lucide-icon name="refresh-cw" [size]="16"></lucide-icon>
        <span>{{ 'COMMON.BUTTONS.RELOAD' | translate }}</span>
    </button>
    <button type="button" class="btn btn-outline-primary report-viewer-action" (click)="closeModal()" rippleEffect>
        <lucide-icon name="x" [size]="16"></lucide-icon>
        <span>{{ 'COMMON.BUTTONS.CLOSE' | translate }}</span>
    </button>
</div>
